import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

type AlertProps = ComponentPropsWithoutRef<typeof Alert>;
type AlertPropsWithoutChildren = Omit<AlertProps, "children">;

type CompactAlertProps = AlertPropsWithoutChildren & {
  title?: ReactNode;
  message: ReactNode;
  actions?: ReactNode;
};

export default function CompactAlert({
  className,
  title,
  message,
  actions,
  ...props
}: CompactAlertProps) {
  return (
    <Alert
      className={cn(
        "mb-2 py-1.5 [&>svg]:top-1/2 [&>svg]:-translate-y-1/2 [&>svg+div]:translate-y-0",
        className,
      )}
      {...props}
    >
      <AlertDescription className="text-sm leading-5">
        <div className="flex items-center gap-2">
          {title ? (
            <span className="shrink-0 text-[15px] font-semibold leading-5">
              {title}
            </span>
          ) : null}
          <span
            className={cn("min-w-0 flex-1 truncate", title && "opacity-95")}
          >
            {message}
          </span>
          {actions ? <div className="shrink-0 ml-auto">{actions}</div> : null}
        </div>
      </AlertDescription>
    </Alert>
  );
}
